import React from 'react';

const PageContainer = ({ children }) => (
    <div className="container py-5 page-container">
        {children}
    </div>
);

export default PageContainer;
